import * as yup from 'yup'
import { THIS_FIELD_IS_MANDATORY_MESSAGE } from '../constants/validations'

export const ContractInfRequestSchema = yup.object().shape({
  needText: yup.boolean(),
  clientNote: yup
    .string()
    .when('needText', { is: true, then: yup.string().required(THIS_FIELD_IS_MANDATORY_MESSAGE) }),
})
